export default __webpack_public_path__ + "static/media/naver_blog.1f3f0765.svg";